import React from "react";

import { useTranslation } from "react-i18next";

export default function GamingHistoryHeader() {
	const { t } = useTranslation();

	return (
		<div className="card--primary__header">
			<div className="card--primary__title title--primary">
				{t<string>("GAMING_HISTORY.TITLE")}
			</div>
		</div>
	);
}
